import { FieldToFocusDirective } from './field-to-focus/field-to-focus.directive';
import { PhoneMaskDirective } from './phone-input-mask/phone-input-mask.directive';

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const directives: any[] = [FieldToFocusDirective, PhoneMaskDirective];

export * from './field-to-focus/field-to-focus.directive';
export * from './phone-input-mask/phone-input-mask.directive';
